module.exports = __webpack_public_path__ + "static/media/influence_2stars.8217db15.png";